/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable react/display-name */
import copy from 'copy-to-clipboard';
import imgURL from '../../../../../../lib/imgURL';
import notify from '../../../../../../lib/notifiy';
import React from 'react';
import moment from 'moment';

export const TRANSACTIONS_TAB_OPTIONS: () => {
  label: string | JSX.Element;
  value: any;
}[] = () => [
  { label: `Transaction Details`, value: 'TRANSACTION_DETAILS' },
  {
    label: 'Transaction Status',
    value: 'TRANSACTION_STATUS',
  },
  { label: `Refund/Chargeback Details`, value: 'REFUND/CHARGEBACK_DETAILS' },
  {
    label: 'Settlement Details',
    value: 'SETTLEMENT_DETAILS',
  },
];

export const onCopy = (merchantAndTransactionData) => {
  copy(merchantAndTransactionData?.data);
  notify({
      type: 'success',
      message: 'Success',
      description: `${merchantAndTransactionData?.value} is copied`,
    });
};

export const tableConstants = (
  columnsOptions: any,
  columnIdHandler?: any,
  isExpandedModalopen?: boolean,
  isEdge?: boolean,
  setIsTransactionDataModalOpen?: any,
  setMerchantAndTransactionData?: any,
  name?: string,
): any => {
  const tableData: any = [];
  columnsOptions.forEach((item) => {
    if (!item.selected) return;
    const obj: any = {};
    obj.key = item.value;
    obj.dataIndex = item.value;
    obj.title = item.label;
    obj.sorter = item.sorter;
    obj.ellipsis = true;
    obj.align = 'center';
    obj.isColumnVisible = isEdge && (item.value === "pluralTransactionId" || item.value === 'edgeMid') ? false : true;
    
    obj.render = (_text, rowData) => {
      if (item.value !== 'merchantReturnUrl' && item.value !== 'acquirerTidMapping') {
        if (item.value === 'RefundDate') {
          return rowData[item.value]
            ? moment(rowData[item.value], 'YYYY-MM-DD HH:mm:ss.SS').format('DD MMM YYYY, hh:mm A')
            : 'NA';
        }

        return (
          <label
            onClick={
              item?.clickable &&
              rowData[item.value] &&
              rowData[item.value] !== 'NA' &&
              isExpandedModalopen &&
              columnIdHandler
                ? () => columnIdHandler({ ...rowData, selectedTab: item.value })
                : () => {}
            }
            className={`${name ? name : ''} ` + `${
              item?.clickable &&
              rowData[item.value] &&
              rowData[item.value] !== 'NA' &&
              isExpandedModalopen &&
              'active-link'
            }`}
          >
            {rowData[item?.value] === undefined || rowData[item?.value] === null || rowData[item?.value] === 'null'
              ? 'NA'
              : item?.value === 'originalTransactionAmount' ||
                item?.value === 'captureAmount' ||
                item?.value === 'settlementAmount' ||
                item?.value === 'surchargeAmount' ||
                item?.value === 'refundAmount'
              ? (rowData[item?.value] / 100).toFixed(2)
              : rowData[item?.value]}
          </label>
        );
      } 
      else if (item.value !== 'merchantReturnUrl') {  
        return (
          <label
            onClick={() => {
              setIsTransactionDataModalOpen(true);
              setMerchantAndTransactionData({
                value: item.label,
                data: rowData[item.value],
              });
            }}
            className={`${name ? name : ''} ` +'active-link'}
          >
            {item.label}
          </label>
        );
      } 
      else {
        return (
          <label className={`${name ? name : ''}`}>
            <div className='item-lable-container'>
              <div className='item-lable-ellipsis' title={rowData[item.value]}>
                {rowData[item.value]}
              </div>{' '}
              <div className='item-label-copy-img'>
                <img
                  src={imgURL['copy-icon']}
                  alt='copy'
                  width='20px'
                  height='20px'
                  onClick={() => onCopy({ value: item.label, data: rowData[item.value] })}
                />
              </div>
            </div>
          </label>
        );
      }
    };
    
    tableData.push(obj);
  });
  return tableData;
};


export const tableConstantsForTidList = (columnsOptions) => {
  const tableData: any = [];
  columnsOptions.forEach((item) => {
    const obj: any = {};
    obj.key = item.value;
    obj.dataIndex = item.value;
    obj.title = item.label;
    obj.sorter = false;
    obj.ellipsis = true;
    obj.align = 'center';
    obj.isColumnVisible = true;

    obj.render = (_text, rowData) => {
      return <label>{rowData[item.value]}</label>;
    };

    tableData.push(obj);
  });
  return tableData;
};

export const CUSTOMIZE_TABLE_TABS = [
  { label: `Transaction Details`, value: 'TRANSACTION_DETAILS' },
  {
    label: 'Refund/Chargeback Details',
    value: 'REFUND_CHARGEBACK_DETAILS',
  },
  {
    label: 'Settlement Details',
    value: 'SETTLEMENT_DETAILS',
  },
];

export const CUSTOMIZE_COLUMNS_CHECKBOX = {
  TRANSACTION_DETAILS: [
    {
      value: 'merchantId',
      label: 'Merchant Id',
      selected: true,
      clickable: true,
      sorter: true,
    },
    {
      value: 'pinePgTransactionId',
      label: 'Pine Pg Txn Id',
      selected: true,
      disabled: true,
      clickable: true,
      sorter: true,
    },
    { value: 'pluralTransactionId',
      label: 'Plural Txn Id', 
      selected: true, 
      disabled: true,
      clickable: true, 
      sorter: true,
    },
    { value: 'orderId', label: 'Pine PG Order Id / Order Id', selected: true },
    {
      value: 'merchantUniqueTransactionId',
      label: 'Merchant unq Txn Id',
      selected: true,
      sorter: true,
    },
    { value: 'rrn', label: 'RRN', selected: true, sorter: true },
    { value: 'source', label: 'Source', selected: false },
    { value: 'gateway', label: 'Gateway', selected: false },
    { value: 'paymentMode', label: 'Payment Mode', selected: false },
    { value: 'merchantName', label: 'Merchant Name', selected: false },
    { value: 'transactionDate', label: 'Txn Date', selected: false, sorter: true, },
    // { value: 'transactionTime', label: 'Txn Time', selected: false },
    {
      value: 'transactionAmount',
      label: 'Original Txn Amount',
      selected: false,
      sorter: true,
    },
    {
      value: 'captureAmount',
      label: 'Capture Amount',
      selected: false,
      sorter: true,
    },
    // {
    //   value: 'settlementAmount',
    //   label: 'Settlement Amount',
    //   selected: false,
    // },
    {
      value: 'surchargeAmount',
      label: 'Sur Charge Amount',
      selected: false,
    },
    { value: 'mdrWithGst', label: 'MDR With Gst', selected: false },
    { value: 'currency', label: 'Txn Currency', selected: false },
    { value: 'isEmiTransaction', label: 'is Emi Txn', selected: false },
    { value: 'transactionType', label: 'Txn Type', selected: false },
    { value: 'transactionStatus', label: 'Txn Status', selected: false },
    { value: 'arn', label: 'arn', selected: false },
  ],
  REFUND_CHARGEBACK_DETAILS: [
    { value: 'refund_txn_id', label: 'Pine Pg Txn Id', selected: true },
    { value: 'originalTxnId', label: 'Original Txn Id', selected: true },
    { value: 'RefundDate', label: 'Refund Date', selected: true },
    {
      value: 'refundAmount',
      label: 'Refund Amount',
      selected: true,
    },
    { value: 'refundStatus', label: 'Refund Status', selected: true },
    { value: 'chargebackStatus', label: 'Chargeback Status', selected: true },
    { value: 'source', label: 'Source', selected: true },
    { value: 'refundadjustmentUtr', label: 'Adjustment UTR', selected: false },
    { value: 'refundAdjustmentDate', label: 'Adjustment Date', selected: false },
    {
      value: 'refundAdjustmentBatchId',
      label: 'Adjustment Batch ID',
      selected: false,
    },
    { value: 'rrn', label: 'Refund RRN', selected: false },
    { value: 'arn', label: 'Refund ARN', selected: false },
  ],
  SETTLEMENT_DETAILS: [
    { value: 'transactionId', label: 'Pine Pg Txn Id', selected: true },
    { value: 'isTransactionSettled', label: 'Is Txn. Settled', selected: true },
    { value: 'utrnumber', label: 'Txn Settlment UTR', selected: true },
    {
      value: 'processedDate',
      label: 'Txn Settlment Date',
      selected: true,
    },
    {
      value: 'batchId',
      label: 'Txn Settlment Batch Id',
      selected: true,
    },
    {
      value: 'accountHolderName',
      label: 'Account Holder Name',
      selected: false,
    },
    { value: 'accountNumber', label: 'Account Number', selected: false },
    { value: 'ifsccode', label: 'IFSC Code', selected: false },
    {
      value: 'paymentRejectionReason',
      label: 'Pytm. Rejection Reason',
      selected: false,
    },
    { value: 'arn', label: 'ARN', selected: true },
  ],
  MERCHANTS_DETAILS:[
    {
      value: 'merchantId',
      label: 'Merchant Id',
      selected: true,
      sorter: true,
    },
    {
      value: 'source',
      label: 'Source',
      selected: true,
    },
    {
      value: 'businessName',
      label: 'Business Name',
      selected: true,
      sorter: true,
    },
    {
      value: 'legalName',
      label: 'Merchant Legal Name',
      selected: true,
      sorter: true,
    },
    {
      value: 'acquirerTidMapping',
      label: 'TID List',
      selected: true,
      sorter: true,
    },
    { value: 'merchantOnboardingDate', label: 'onboarding Date', selected: true, sorter: true, },
    { value: 'merchantSpocName', label: 'Merchant Spoc Name', selected: false },
    { value: 'merchantSpocMobileNumber', label: 'Merchant Spoc Mobile Number', selected: false },
    { value: 'merchantSpocEmailId', label: 'Merchant Spoc Email Id', selected: false, sorter: true, },
    { value: 'merchantWebsiteUrl', label: 'Merchant Website URL', selected: true },
    { value: 'merchantReturnUrl', label: 'Merchant Rerturn Url', selected: true },
    { value: 'merchantStatus', label: 'Merchant Status', selected: true, sorter: true, },
    { value: 'merchantSettlementCycle', label: 'Merchant Settlement Cycle', selected: true },
    { value: 'merchantRegisteredBusinessAddress', label: 'Merchant Registered Business Address', selected: false },
    { value: 'merchantRegisteredOperationalAddress', label: 'Merchant Registered Operational Address', selected: false },
    {
      value: 'riskandDispputeContact',
      label: 'Risk & Dispute Contact',
      selected: false,
    },
        {
      value: 'riskandDisputeEmail',
      label: 'Risk & Dispute Email',
      selected: false,
    },
    {
      value: 'edgeMid',
      label: 'Edge Merchant Id',
      selected: false,
      sorter: true,
    },
  ]
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const reducerForCustomizeTableCheckbox = (state, action): any => {
  const { parentType, index, reset = false, selectAll = false } = action;
  if (reset) {
    return { ...CUSTOMIZE_COLUMNS_CHECKBOX };
  }
  const oldState = { ...state };

  if(selectAll) {
    const data = oldState[parentType].map((item) => {
      return {...item, selected: true};
    });
    return {...state, [parentType]: data};
  }

  oldState[parentType][index] = {
    ...state[parentType][index],
    selected: !state[parentType][index].selected,
  };
  return { ...oldState };
};

export const handleTableCustomizeData = (pluralTableData, edgeTableData,tableTabType,CUSTOMIZE_TABLE_TYPES_TABS,updateTableTabType) => {
  const generateTab = (type, data) => ({
    label: (
      <div
        className={`table-heading ${
          tableTabType === type.toUpperCase() ? 'active-tab' : ''
        }`}
      >
        {type.toUpperCase()} <span>({data?.totalRecords || 0})</span>
      </div>
    ),
    value: `${type}Data`,
  });

  if (edgeTableData?.totalRecords && pluralTableData?.totalRecords) {
    CUSTOMIZE_TABLE_TYPES_TABS.push(generateTab('edge', edgeTableData));
    CUSTOMIZE_TABLE_TYPES_TABS.push(
      generateTab('plural', pluralTableData)
    );
  } else if (edgeTableData?.totalRecords) {
    CUSTOMIZE_TABLE_TYPES_TABS.push(generateTab('edge', edgeTableData));
    updateTableTabType('edgeData');
  } else if (pluralTableData?.totalRecords) {
    CUSTOMIZE_TABLE_TYPES_TABS.push(
      generateTab('plural', pluralTableData)
    );
    updateTableTabType('pluralData');
  } else {
    CUSTOMIZE_TABLE_TYPES_TABS.push(generateTab('edge', edgeTableData));
    CUSTOMIZE_TABLE_TYPES_TABS.push(
      generateTab('plural', pluralTableData)
    );
  }
};

export const handleMerchantTableCustomizeData = (tableData,tableTabType,CUSTOMIZE_TABLE_TYPES_TABS,updateTableTabType) => {
  const generateTab = (type, data) => ({
    label: (
      <div
        className={`table-heading ${
          tableTabType === type.toUpperCase() ? 'active-tab' : ''
        }`}
      >
        {type.toUpperCase()} <span>({data?.totalRecords || 0})</span>
      </div>
    ),
    value: `${type}Data`,
  });

  if (tableData?.edgeData && tableData?.pluralData) {
    CUSTOMIZE_TABLE_TYPES_TABS.push(generateTab('edge', tableData.edgeData));
    CUSTOMIZE_TABLE_TYPES_TABS.push(
      generateTab('plural', tableData.pluralData)
    );
    updateTableTabType('edgeData');
  } else if (tableData?.edgeData) {
    CUSTOMIZE_TABLE_TYPES_TABS.push(generateTab('edge', tableData.edgeData));
    updateTableTabType('edgeData');
  } else if (tableData?.pluralData) {
    CUSTOMIZE_TABLE_TYPES_TABS.push(
      generateTab('plural', tableData.pluralData)
    );
    updateTableTabType('pluralData');
  } else {
    CUSTOMIZE_TABLE_TYPES_TABS.push(generateTab('edge', tableData.edgeData));
    CUSTOMIZE_TABLE_TYPES_TABS.push(
      generateTab('plural', tableData.pluralData)
    );
  }
};

export const tidColumnCategory = [
  { label: 'TID List', selected: true, sorter: true, value: 'tid' },
  { label: 'Acquiring Bank Name', selected: true, sorter:true, value: 'acquiringBankName'},
];

